import React from "react";
import { Radio, Box, Typography, Divider, Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import HomeIcon from "@mui/icons-material/Home";
import { Briefcase, Buildings, House } from "@phosphor-icons/react";

const AddressTypeIcon = ({ type }) => {
  switch (type) {
    case "Home":
      return <House size={24} color="var(--neutral-700)" weight="bold" />;
    case "Work":
      return <Briefcase size={24} color="var(--neutral-700)" weight="bold" />;
    default:
      return <Buildings size={24} color="var(--neutral-700)" weight="bold" />;
  }
};
const AddressCard = ({
  selected,
  onSelect,
  item,
}) => {
  return (
    <CardContainer selected={selected} onClick={() => onSelect(item)}>
      <Box
        display="flex"
        alignItems="center"
        gap={2}
        sx={{ position: "relative" }}
      >
        <IconWrapper>
          <AddressTypeIcon type={item?.address_type} />
        </IconWrapper>
        <Box flex={1} sx={{ gap: 1, flexDirection: "column", display: "flex" }}>
          <Title>{item?.address_type}</Title>
          <Address>{item?.full_address}</Address>
          <PhoneNumber>
            Phone number: <strong>{`+91 ${item?.billing_mobile}`}</strong>
          </PhoneNumber>
        </Box>
        <StyledRadio checked={selected} size="small" />
      </Box>
      <Divider sx={{ my: 1, backgroundColor: "var(--neutral-200)" }} />
      <Footer>
        <ActionButton>Delete</ActionButton>
        <Divider
          orientation="vertical"
          flexItem
          sx={{ mx: 1, backgroundColor: "var(--neutral-200)" }}
        />
        <ActionButton>Edit</ActionButton>
      </Footer>
    </CardContainer>
  );
};

// Styled Components using MUI
const CardContainer = styled(Box)(({ selected }) => ({
  border: `1px solid ${
    selected ? "var(--primary-red-300)" : "var(--neutral-200)"
  }`,
  borderRadius: "8px",
  padding: "12px",
  cursor: "pointer",
  transition: "border 0.3s ease-in-out",
  "&:hover": {
    border: "1px solid var(--primary-red-300)",
  },
}));

const IconWrapper = styled(Box)({
  width: 48,
  height: 48,
  backgroundColor: "white",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "1px solid var(--neutral-300)",
  alignSelf: "flex-start",
});

const Title = styled(Typography)({
  fontSize: "16px",
  fontWeight: 600,
  textAlign: "left",
  lineHeight: "150%",
  color: "var(--neutral-black)",
});

const Address = styled(Typography)({
  fontSize: "14px",
  fontWeight: 500,
  textAlign: "left",
  lineHeight: "157%",
  color: "var(--neutral-700)",
  minHeight: "40px",
});

const PhoneNumber = styled(Typography)({
  fontSize: "12px",
  fontWeight: 400,
  textAlign: "left",
  lineHeight: "167%",
  color: "var(--neutral-600)",
  "& strong": {
    fontWeight: 500,
    color: "var(--neutral-black)",
  },
});

const StyledRadio = styled(Radio)({
  position: "absolute",
  top: "4px",
  right: "4px",
  color: "var(--primary-red-300)",
  padding: 0,
});

const Footer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-evenly",
});

const ActionButton = styled(Button)({
  width: "100%",
  textAlign: "center",
  fontSize: "14px",
  textTransform: "none",
  fontSize: "12px",
  fontWeight: 600,
  lineHeight: "167%",
  color: "var(--neutral-800)",
  "&:hover": {
    color: "var(--primary-red-300)",
  },
});

export default AddressCard;
